module.exports = __webpack_public_path__ + "media/images/game_icon/vi/VG0002-1a7921949d6426c36938c1c1c4b01a40.png";